// app_client/src/components/products/ProductForm.jsx
import React from 'react';
import { Package, Loader2, Save, Zap, Hash, Tag, ShoppingCart, Banknote } from 'lucide-react';

const ProductForm = ({ 
  formData,
  handleChange,
  handleUpdate,
  loading,
  isNew,
  isCodeTaken,
  onCodeBlur,
  stockQuantityDisabled
}) => {
  const isMaterial = formData.type === 'Material';

  return (
    <div className="bg-white rounded-3xl p-6 shadow-sm border border-slate-100">
      <h3 className="text-lg font-black text-slate-800 mb-6 flex items-center gap-2">
        {isMaterial ? <Package size={20} className="text-amber-500" /> : <Zap size={20} className="text-purple-500" />}
        {isNew ? 'Yeni Ürün/Hizmet Tanımı' : 'Ürün/Hizmet Bilgileri'}
      </h3>
      
      <form onSubmit={handleUpdate} className="space-y-6">
        {/* TEMEL BİLGİLER */}
        <div className="space-y-4">
          <div>
            <label className="text-[10px] font-black text-slate-400 uppercase ml-1 tracking-widest">Ürün/Hizmet Adı *</label>
            <input name="name" value={formData.name} onChange={handleChange} required
              className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm font-bold focus:border-blue-500 outline-none transition-all" />
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1 tracking-widest">Tür</label>
              <select name="type" value={formData.type} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm font-bold outline-none focus:border-blue-500">
                <option value="Material">Malzeme / Ürün</option>
                <option value="Service">Hizmet / İşçilik</option>
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1 tracking-widest">Kod / SKU *</label>
              <div className="relative">
                <input 
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  onBlur={onCodeBlur} // Artık prop'tan geliyor
                  className={`w-full px-4 py-2.5 bg-slate-50 border rounded-xl text-sm font-bold outline-none transition-all ${
                    isCodeTaken ? 'border-rose-500 bg-rose-50 text-rose-600' : 'border-slate-200 focus:border-blue-500'
                  }`}
                />
                {isCodeTaken && (
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-rose-500 text-[9px] font-black uppercase bg-white px-1">
                    Kullanımda
                  </span>
                )}
              </div>
            </div>
            <div className="col-span-2 lg:col-span-1">
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1 tracking-widest">Birim</label>
              <select name="unit" value={formData.unit} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm font-bold outline-none focus:border-blue-500">
                <option value="Adet">Adet</option>
                <option value="Saat">Saat</option>
                <option value="Gün">Gün</option>
                <option value="Set">Set</option>
                <option value="Litre">Litre</option>
                <option value="Paket">Paket</option>
              </select>
            </div>
          </div>
        </div>

        {/* ALIŞ FİYATLANDIRMASI (MALİYET) */}
        <div className="p-5 bg-slate-50/80 rounded-3xl border border-slate-100 space-y-4">
          <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] flex items-center gap-2">
            <ShoppingCart size={14} /> Alış Bilgileri (Maliyet)
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="col-span-2 md:col-span-1">
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">Alış Fiyatı</label>
              <input type="number" name="purchasePrice" value={formData.purchasePrice} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold focus:border-blue-500 outline-none" />
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">Para Birimi</label>
              <select name="purchaseCurrency" value={formData.purchaseCurrency} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold outline-none">
                <option value="TRY">TRY (₺)</option>
                <option value="USD">USD ($)</option>
                <option value="EUR">EUR (€)</option>
                <option value="GBP">GBP (£)</option>
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">KDV (%)</label>
              <input type="number" name="purchaseVatRate" value={formData.purchaseVatRate} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold outline-none" />
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">KDV Durumu</label>
              <select name="purchaseVatIncluded" value={formData.purchaseVatIncluded.toString()} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold outline-none text-slate-600">
                <option value={false}>Hariç (+KDV)</option>
                <option value={true}>Dahil</option>
              </select>
            </div>
          </div>
        </div>

        {/* SATIŞ FİYATLANDIRMASI */}
        <div className="p-5 bg-blue-50/30 rounded-3xl border border-blue-100/50 space-y-4">
          <p className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] flex items-center gap-2">
            <Tag size={14} /> Satış Bilgileri
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="col-span-2 md:col-span-1">
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">Satış Fiyatı</label>
              <input type="number" name="salePrice" value={formData.salePrice} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-blue-200 rounded-xl text-sm font-bold text-blue-700 outline-none focus:ring-2 ring-blue-500/10" />
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">Para Birimi</label>
              <select name="saleCurrency" value={formData.saleCurrency} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold outline-none">
                <option value="TRY">TRY (₺)</option>
                <option value="USD">USD ($)</option>
                <option value="EUR">EUR (€)</option>
                <option value="GBP">GBP (£)</option>
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">KDV (%)</label>
              <input type="number" name="saleVatRate" value={formData.saleVatRate} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold outline-none" />
            </div>
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1">KDV Durumu</label>
              <select name="saleVatIncluded" value={formData.saleVatIncluded.toString()} onChange={handleChange}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold outline-none text-blue-600">
                <option value={false}>Hariç (+KDV)</option>
                <option value={true}>Dahil</option>
              </select>
            </div>
          </div>
        </div>

        {/* STOK BİLGİLERİ - Sadece Malzeme ise Gösterilir */}
        {isMaterial && (
          <div className="p-5 bg-amber-50/50 rounded-3xl border border-amber-100 space-y-4">
            <p className="text-[10px] font-black text-amber-600 uppercase tracking-[0.2em] flex items-center gap-2">
              <Hash size={14} /> Stok Yönetimi
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
                  Mevcut Stok Miktarı
                </label>
                <input 
                  type="number" 
                  name="stockQuantity" 
                  value={formData.stockQuantity} 
                  onChange={handleChange}
                  // Statik 'disabled' yerine prop'tan gelen değeri kullanıyoruz:
                  disabled={stockQuantityDisabled} 
                  // Görsel sınıfları da duruma göre dinamik yapabiliriz:
                  className={`w-full px-4 py-2.5 border rounded-xl text-sm font-bold outline-none transition-all ${
                    stockQuantityDisabled 
                      ? 'bg-slate-50 border-slate-200 text-slate-400 cursor-not-allowed' 
                      : 'bg-white border-amber-200 text-slate-800'
                  }`}
                />
                <p className="text-[9px] text-slate-400 mt-1 ml-1 italic">
                  * Stok miktarı sadece fatura ve fiş hareketleri ile güncellenir.
                </p>
              </div>
              <div>
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1">Kritik Stok Seviyesi</label>
                <input type="number" name="minStockLevel" value={formData.minStockLevel} onChange={handleChange}
                  className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold focus:border-amber-500 outline-none" />
              </div>
            </div>
          </div>
        )}

        <div>
          <label className="text-[10px] font-black text-slate-400 uppercase ml-1 tracking-widest">Ürün Açıklaması & Notlar</label>
          <textarea name="description" value={formData.description} onChange={handleChange} rows="2"
            placeholder="Ürün detayları, teknik özellikler..."
            className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold focus:ring-4 ring-blue-500/5 outline-none resize-none transition-all" 
          />
        </div>

        <button type="submit" disabled={loading || isCodeTaken}
          className="w-full flex items-center justify-center gap-2 py-4 rounded-2xl font-black bg-slate-900 hover:bg-black text-white shadow-xl disabled:bg-slate-300 transition-all active:scale-[0.98]">
          {loading ? <Loader2 size={20} className="animate-spin" /> : <Save size={20} />}
          {isCodeTaken ? 'KOD ÇAKIŞMASINI DÜZELTİN' : (isNew ? 'ÜRÜNÜ SİSTEME KAYDET' : 'GÜNCELLEMELERİ KAYDET')}
        </button>
      </form>
    </div>
  );
};

export default ProductForm;